import { IPairUserRole } from '../interfaces/pairUserRole';
import { PataviumRole } from '../enums/role.enum.model';

export class PairUserRole implements IPairUserRole {
    idUser: number;
    idRole: PataviumRole;

    constructor(ur?: IPairUserRole) {
        if (ur) {
            this.idUser = ur.idUser;
            this.idRole = ur.idRole;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/models/request-and-responses/rest-api/classes/pairUserRole.ts